// extracted by mini-css-extract-plugin
export default {"subtitle":"SectionSubtitle_subtitle__f6qII"};